import styled from 'styled-components';

import { LocalizedCurrency } from 'shared/components/LocalizedCurrency';

interface IWindowPriceDisplayProps {
  currentPrice: number;
  isUnderRetail?: boolean;
  retailPrice?: number;
}

export const WindowPriceDisplay = ({
  currentPrice,
  isUnderRetail,
  retailPrice,
}: IWindowPriceDisplayProps) => {
  return (
    <WindowPriceDisplay.Wrapper>
      {isUnderRetail && (
        <WindowPriceDisplay.OriginalPrice price={retailPrice} roundDownToDollarAmount />
      )}
      <WindowPriceDisplay.UnderRetail price={currentPrice} roundDownToDollarAmount />
    </WindowPriceDisplay.Wrapper>
  );
};

WindowPriceDisplay.Wrapper = styled.button`
  display: flex;
  flex-direction: row;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

WindowPriceDisplay.OriginalPrice = styled(LocalizedCurrency)`
  margin-right: 4px;
  text-decoration: line-through;
`;

WindowPriceDisplay.UnderRetail = styled(LocalizedCurrency)``;
